export const CHECKLIST_MANAGMENT_AND_CLEANING_DEV = 154;
export const CHECKLIST_MANAGMENT_AND_CLEANING_PRO = 135;
export const CHECKLIST_TECHNICAL_VISIT_POST_SALE_DEV = 155;
export const CHECKLIST_TECHNICAL_VISIT_POST_SALE_PRO = 134;
export const CHECKLIST_TECHNICAL_VISIT_POST_SALE_PRO_V2 = 145
export const CHECKLIST_TECHNICAL_VISIT_POST_SALE_DEV_V2 = 161;
export const CHECKLIST_TECHNICAL_VISIT_POST_SALE_DEV_V3 = null;
export const CHECKLIST_TECHNICAL_VISIT_POST_SALE_PRO_V3 = 236;
export const CHECKLIST_TECHNICAL_VISIT_FLUX_HOME_PRO = 146;
export const CHECKLIST_TECHNICAL_VISIT_FLUX_HOME_DEV = 162;
export const CHECKLIST_FIELD_REPORT_DEV = 165;
export const CHECKLIST_FIELD_REPORT_PRO = 223;

export const verifyIfChecklistFieldReport = (item) => {
  let checklistId = item.checklist ? item.checklist.id : item.id;
  if (process.env.VUE_APP_ENVIROMENT_VARIABLE === "development") {
    return checklistId == CHECKLIST_FIELD_REPORT_DEV;
  }
  return checklistId == CHECKLIST_FIELD_REPORT_PRO;
};

export const verifyIfChecklistIdTechnicalReport = (item) => {
  let checklistId = item.checklist ? item.checklist.id : item.id;
  if (process.env.VUE_APP_ENVIROMENT_VARIABLE === "development") {
    return (
      checklistId == CHECKLIST_TECHNICAL_VISIT_POST_SALE_DEV ||
      checklistId == CHECKLIST_MANAGMENT_AND_CLEANING_DEV ||
      checklistId == CHECKLIST_TECHNICAL_VISIT_FLUX_HOME_DEV ||
      checklistId == CHECKLIST_TECHNICAL_VISIT_POST_SALE_DEV_V2 ||
      checklistId == CHECKLIST_TECHNICAL_VISIT_POST_SALE_DEV_V3
    );
  }
  return (
    checklistId == CHECKLIST_TECHNICAL_VISIT_POST_SALE_PRO ||
    checklistId == CHECKLIST_MANAGMENT_AND_CLEANING_PRO ||
    checklistId == CHECKLIST_TECHNICAL_VISIT_FLUX_HOME_PRO ||
    checklistId == CHECKLIST_TECHNICAL_VISIT_POST_SALE_PRO_V2 ||
    checklistId == CHECKLIST_TECHNICAL_VISIT_POST_SALE_PRO_V3
  );
};

export const getTypeChecklistFromChecklist = (item) => {
  let checklistId = item.checklist ? item.checklist.id : item.id;
  if (process.env.VUE_APP_ENVIROMENT_VARIABLE === "development") {
    if (checklistId == CHECKLIST_FIELD_REPORT_DEV) {
      return 'reportedeterreno'
    }
    if (checklistId == CHECKLIST_TECHNICAL_VISIT_POST_SALE_DEV_V3) {
      return 'informedevisitav3postventa';
    }
    if (checklistId == CHECKLIST_TECHNICAL_VISIT_POST_SALE_DEV_V2 || checklistId == CHECKLIST_TECHNICAL_VISIT_FLUX_HOME_DEV) {
      return checklistId == CHECKLIST_TECHNICAL_VISIT_POST_SALE_DEV_V2 ? "informedevisitav2postventa" : "informedevisitav2fluxhome";
    }
    return 'informedevisita';
  } else {
    if (checklistId == CHECKLIST_FIELD_REPORT_PRO) {
      return 'reportedeterreno'
    }
    if (checklistId == CHECKLIST_TECHNICAL_VISIT_POST_SALE_PRO_V3) {
      return 'informedevisitav3postventa';
    }
    if (checklistId == CHECKLIST_TECHNICAL_VISIT_POST_SALE_PRO_V2 || checklistId == CHECKLIST_TECHNICAL_VISIT_FLUX_HOME_PRO) {
      return checklistId == CHECKLIST_TECHNICAL_VISIT_POST_SALE_PRO_V2 ? "informedevisitav2postventa" : "informedevisitav2fluxhome";
    }
    return 'informedevisita';
  }
}